import PropTypes from 'prop-types';

const pluginServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  register: PropTypes.func,
  getPlugin: PropTypes.func,
});

export default pluginServiceShape;
